const why = [
    {
        title: 'Streamlined Process',
        image: 'insights/whyPeekage/postSamplingAction.svg',
        content: 'From recruitment to fulfillment, data collection, and analysis, everything is fully automated and under one roof. ',
    },
    {
        title: 'In-store experience data',
        image: 'insights/whyPeekage/collectData.svg',
        content: 'Capture users\' in-store experiences to identify optimization points and gain insights into product visibility and performance.',
    },
    {
        title: 'Lightning Speed',
        image: 'arts/Speed.svg',
        content: 'Receive live consumer data on your dashboard in a matter of days, not weeks.',
    },
    {
        title: '1st Party Consumer Network',
        image: 'arts/Fulfilment.svg',
        content: 'Quickly recruit from a community of 5M+ diverse and engaged consumers across North America. ',
    },
    {
        title: 'Targeting and Segmentation',
        image: 'arts/Retarget.svg',
        content: ' Leverage 200+ shoppers’ attributes and consumption habits to segment and target the ideal audience.',
    },
    {
        title: 'Affordable',
        image: 'arts/Affordable.svg',
        content: 'With one subscription all teams get big-market-research-firm quality at a fraction of the cost.',
    },
    {
        title: 'One Platform for all testing needs',
        image: 'arts/Opt-in-lg.svg',
        content: 'Peekage offers a comprehensive suite of product testing methods, incorporating the latest quant and qual research methodologies, all in one place.',
    },
    {
        title: 'Simpler to Use',
        image: 'arts/online-experience-lg.svg',
        content: 'No need to have a data scientist in-house. Simply use our AI to generate a fully optimized study and obtain actionable insights effortlessly.',
    },
];

export default why;
